import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { Shield, Lock, Globe, Check, Zap, Sparkles, ArrowUpCircle } from 'lucide-react';
const CHECKOUT_URL = 'https://allsetvault.myshopify.com/cart/47462286426243:1';
const MASTER_URL = 'https://allsetvault.myshopify.com/cart/47463063486595:1';
const comboIncludes = ['120 ready-to-teach Spanish lessons', 'Organized progressively for Spanish 1 and Spanish 2', '40+ weeks of fresh, non-repeating content', 'Every lesson completely structured', 'Learning objectives, vocabulary, grammar, activities and assessments included', 'Bonus 1 — Spanish Grammar Made Simple', 'Bonus 2 — 100 Conversation Activities', 'Bonus 3 — Assessment and Quiz Bank', 'Bonus 4 — 30 Culture Lessons', 'Bonus 5 — 30 Emergency Lessons', '7-day money-back guarantee', 'Immediate access', 'PDF format — ready to use'];
const masterIncludes = ['Spanish 1 & Spanish 2 Full-Year Pacing Guides', 'Weekly Teaching Plans (Monday–Friday)', '180 Daily Bell Ringers + 180 Exit Tickets', 'Gradebook and Progress Trackers', 'Classroom Management in Spanish (scripts & phrases)', 'Substitute Teacher System', 'Skills and Curriculum Alignment Map', 'Parent & Student Communication Templates'];
export function PricingSection() {
  return <section id="pricing" className="py-20 px-4 bg-black relative" data-id="element-193">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-[500px] bg-gold/20 blur-[120px] rounded-full pointer-events-none" data-id="element-194"></div>

      <div className="max-w-3xl mx-auto relative z-10" data-id="element-195">
        <div className="text-center mb-10" data-id="element-196">
          <h2 className="text-3xl md:text-5xl font-serif font-bold mb-3" data-id="element-197">
            Your Complete Offer Today
          </h2>
          <p className="text-gold-light text-sm md:text-base" data-id="element-198">
            The complete teaching system + 5 strategic bonuses — ready for your
            next class.
          </p>
        </div>

        <div className="space-y-8" data-id="element-199">
          {/* OFFER 1 — $27 Complete Package */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-card border-2 border-gold rounded-3xl p-1 relative shadow-[0_0_50px_rgba(212,175,55,0.2)]" data-id="element-200">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-201">
              <Sparkles size={14} data-id="element-202" /> Complete Package
            </div>

            <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-203">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-204">
                Spanish Teacher Ready™
              </h3>
              <p className="text-base text-gray-300 mb-6" data-id="element-205">
                Everything you need to teach Spanish 1 and Spanish 2 with
                confidence.
              </p>

              <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-206">
                {comboIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-207">
                    <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-208" />
                    <span data-id="element-209">{item}</span>
                  </li>)}
              </ul>

              <div className="mb-6" data-id="element-210">
                <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-211">
                  USD 105.00
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-212">
                  <span className="text-2xl md:text-3xl text-white" data-id="element-213">
                    TODAY ONLY:
                  </span>
                  <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-214">
                    USD 27.00
                  </span>
                </div>
              </div>

              <Button href={CHECKOUT_URL} target="_blank" onLinkClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Spanish Teacher Ready Complete System',
                  value: 27.0,
                  currency: 'USD'
                });
              }
            }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-215">
                🟡 GET THE COMPLETE TEACHING SYSTEM NOW
              </Button>

              <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400 mb-4" data-id="element-216">
                <span className="flex items-center gap-1.5" data-id="element-217">
                  <Lock size={12} className="text-gold" data-id="element-218" /> Secure payment
                </span>
                <span className="flex items-center gap-1.5" data-id="element-219">
                  <Zap size={12} className="text-gold" data-id="element-220" /> Immediate access
                </span>
                <span className="flex items-center gap-1.5" data-id="element-221">
                  <Shield size={12} className="text-gold" data-id="element-222" /> 7-day guarantee
                </span>
              </div>

              <div className="bg-white/5 border border-white/10 rounded-xl p-3 max-w-md mx-auto flex items-start gap-2.5 text-left" data-id="element-223">
                <Globe className="text-gold shrink-0 mt-0.5" size={14} data-id="element-224" />
                <p className="text-[11px] text-gray-400 leading-snug" data-id="element-225">
                  Pay in your local currency. The amount adjusts automatically
                  based on your country.
                </p>
              </div>
            </div>
          </motion.div>

          {/* OFFER 2 — $35 Master System (directly below, no separating text) */}
          <motion.div initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-navy-card border-2 border-gold/50 rounded-3xl p-1 relative shadow-[0_0_40px_rgba(212,175,55,0.12)]" data-id="element-226">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gold-gradient text-black font-bold px-5 py-1.5 rounded-full shadow-lg uppercase tracking-wider text-xs flex items-center gap-1.5 whitespace-nowrap" data-id="element-227">
              <ArrowUpCircle size={14} data-id="element-228" /> Optional Add-On
            </div>

            <div className="bg-black rounded-[1.3rem] p-6 md:p-10 text-center" data-id="element-229">
              <h3 className="text-2xl md:text-3xl font-serif font-bold text-gold-gradient mb-3" data-id="element-230">
                Spanish Teacher Master System
              </h3>
              <p className="text-base text-gray-300 mb-6" data-id="element-231">
                Full-year planning, pacing and classroom management toolkit —
                organize, pace and manage your 120 lessons across a full school
                year.
              </p>

              <ul className="text-left max-w-md mx-auto space-y-2 mb-6 bg-gold/5 border border-gold/20 rounded-xl p-4" data-id="element-232">
                {masterIncludes.map((item, i) => <li key={i} className="flex items-start gap-2 text-sm text-gray-200" data-id="element-233">
                    <Check size={16} className="text-gold shrink-0 mt-0.5" data-id="element-234" />
                    <span data-id="element-235">{item}</span>
                  </li>)}
              </ul>

              <div className="mb-6" data-id="element-236">
                <span className="text-lg text-gray-500 line-through block mb-1" data-id="element-237">
                  USD 78.00
                </span>
                <div className="flex items-baseline justify-center gap-2" data-id="element-238">
                  <span className="text-2xl md:text-3xl text-white" data-id="element-239">
                    ADD FOR ONLY:
                  </span>
                  <span className="text-4xl md:text-5xl font-bold text-gold" data-id="element-240">
                    USD 35.00
                  </span>
                </div>
              </div>

              <Button href={MASTER_URL} target="_blank" onLinkClick={() => {
              if (typeof window !== 'undefined' && (window as any).fbq) {
                ;
                (window as any).fbq('track', 'InitiateCheckout', {
                  content_name: 'Spanish Teacher Master System Upsell',
                  value: 35.0,
                  currency: 'USD'
                });
              }
            }} className="w-full md:w-auto text-base md:text-lg py-4 px-8 mb-5" data-id="element-241">
                🟡 YES — ADD THE MASTER SYSTEM TO MY ORDER
              </Button>

              <div className="flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs text-gray-400" data-id="element-242">
                <span className="flex items-center gap-1.5" data-id="element-243">
                  <Lock size={12} className="text-gold" data-id="element-244" /> Secure payment
                </span>
                <span className="flex items-center gap-1.5" data-id="element-245">
                  <Zap size={12} className="text-gold" data-id="element-246" /> Immediate access
                </span>
                <span className="flex items-center gap-1.5" data-id="element-247">
                  <Shield size={12} className="text-gold" data-id="element-248" /> 7-day guarantee
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}